var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 23,
    viewBox: "0 0 12 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7652 12.8297L11.3622 8.9501H7.6274V6.43247C7.6274 5.37108 8.14909 4.33651 9.82193 4.33651H11.52V1.0336C11.52 1.0336 9.97892 0.77146 8.5056 0.77146C5.4296 0.77146 3.41918 2.62948 3.41918 5.99321V8.9501H0V12.8297H3.41918V22.2084C4.10478 22.3156 4.80747 22.3715 5.52329 22.3715C6.23911 22.3715 6.9418 22.3156 7.6274 22.2084V12.8297H10.7652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8843cc2409f09d641a3eb5e29a23dee4.svg";
export { ForwardRef as ReactComponent };